// Generating a link to a specific place in the content
// where the image or video is located
export const getAnchor = (id) => {
  const slashMatchRegex = new RegExp("\\/", "g");
  return id.replace(slashMatchRegex, "-");
};
